import APIService from '@/services/api-service'
const resource = '/client'

class ClientService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getClient (id: any) {
    return this.connector.get(`${resource}/${id}`)
  }

  public getAddress (clientId: any, type: any) {
    return this.connector.get(`${resource}/${clientId}/address/${type}`)
  }

  public getContactDetails (contactId: any) {
    return this.connector.get(`${resource}/contact/${contactId}`)
  }

  public checkClient (code: any) {
    return this.connector.get(`${resource}/check/${code}`)
  }

  public create (client: any) {
    return this.connector.post(`${resource}/create`, { client: client })
  }

  public update (client: any) {
    return this.connector.put(`${resource}/update`, { client: client })
  }
}

export default new ClientService()
